/* Dreavaya tracking (WS1): paid-traffic flag, first-touch attribution saved on the cart, custom events.
   No redirects, no click ids or personal data sent anywhere; content_for_header pixels are untouched. */
(function () {
  const DV = (window.DV = window.DV || {});
  const publish = (name, data) => { try { Shopify.analytics.publish(name, data); } catch (e) {} };
  const sent = {};
  DV.track = { publish, sent };
  const ss = { get: (k) => { try { return sessionStorage.getItem(k); } catch (e) { return null; } }, set: (k, v) => { try { if (v === null) sessionStorage.removeItem(k); else sessionStorage.setItem(k, v); } catch (e) {} } };
  const q = new URLSearchParams(location.search), body = document.body;
  const clk = q.get('ttclid') ? 'tt' : q.get('fbclid') ? 'fb' : q.get('gclid') ? 'g' : '';
  const paid = /^(paid|cpc|ppc|paid_?social|paidsocial)$/i.test(q.get('utm_medium') || '');
  const adTpl = body.classList.contains('dv-ad');

  // 1. ad mode for the rest of the session: CSS hides the Letters note and the chat/TikTok bubbles
  if (adTpl || clk || paid || ss.get('dvAd') === '1') { ss.set('dvAd', '1'); document.documentElement.classList.add('dv-ad'); }

  // 2. first touch of the session (later pages never overwrite it), written once onto the cart as hidden _dv_* attributes
  if (!ss.get('dvAttr')) {
    ss.set('dvAttr', JSON.stringify({ land: (body.dataset.dvTpl || '') + ':' + (body.dataset.dvH || ''), src: q.get('utm_source') || '', med: q.get('utm_medium') || '', cmp: q.get('utm_campaign') || '', cnt: q.get('utm_content') || '', clk }));
  }
  const dvMap = () => {
    let a = {}; try { a = JSON.parse(ss.get('dvAttr') || '{}'); } catch (x) {}
    const map = { _dv_landing: a.land, _dv_utm_source: a.src, _dv_utm_medium: a.med, _dv_utm_campaign: a.cmp, _dv_utm_content: a.cnt, _dv_click: a.clk }, out = {};
    Object.keys(map).forEach((k) => { if (map[k]) out[k] = String(map[k]).slice(0, 100); });
    return out;
  };
  // Shop Pay express on the product page builds its own new cart (no cart attributes), so the same values ride on its
  // line as hidden properties. Only this form: on the normal add path they would split one variant into separate lines.
  const xf = document.getElementById('DvExpressForm');
  if (xf) {
    const m = dvMap();
    Object.keys(m).forEach((k) => {
      if (xf.querySelector('[name="properties[' + k + ']"]')) return;
      const i = document.createElement('input'); i.type = 'hidden'; i.name = 'properties[' + k + ']'; i.value = m[k]; xf.appendChild(i);
    });
  }
  document.addEventListener('dv:cart', (e) => {
    const c = e.detail || {};
    if (!c.item_count || (c.attributes && c.attributes._dv_landing) || ss.get('dvAttrSent')) return;
    const attributes = dvMap();
    if (!attributes._dv_landing) return;
    ss.set('dvAttrSent', '1');
    // queued behind any add in flight (DV.cart.write), so the attribute write can never overwrite a fresh line
    const w = window.DV && DV.cart && DV.cart.write;
    (w ? w('cart/update.js', { attributes }) : fetch(((window.DV_CFG && DV_CFG.root) || '/') + 'cart/update.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ attributes }) }).then((r) => { if (!r.ok) throw new Error(r.status); }))
      .catch(() => ss.set('dvAttrSent', null));
  });

  // 3. ad landing view, once per page load (Shopify.analytics may only exist after the pixel scripts load)
  if (adTpl) {
    const go = () => { if (sent.dv_landing_view) return; sent.dv_landing_view = true; publish('dv_landing_view', { tpl: body.dataset.dvTpl || '', handle: body.dataset.dvH || '' }); };
    if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) go(); else addEventListener('load', go, { once: true });
  }
})();
